define('templates/simulationTemplates',['templates/template-builder'], function(TemplateBuilder) {
    return function(options) {
        var templateBuilder = new TemplateBuilder();
        
    	return {
	        /**
	         * HEADERS -------------------------------------------------------
	         */
	        'headers' : {
	            'name' : options.noSort ? templateBuilder.basicHeader('name', 'Name') : templateBuilder.sortableHeader('name', 'Name', 'nameCI'),
	            'coverageConfName' : templateBuilder.basicHeader('coverageConfName', 'Coverage configuration'),
	            'forecast' : templateBuilder.basicHeader('forecast', 'Forecast'),
	            'coverageCloned' : templateBuilder.basicHeader('coverageCloned', 'Coverage cloned'),
	            'lastCoverageRunningDate' : templateBuilder.basicHeader('lastCoverageRunningDate', 'Last coverage run'),
	            'authorName' : templateBuilder.basicHeader('authorName', 'Author'),
	            'readOnlyMode' : templateBuilder.basicHeader('readOnlyMode', 'Read-only'),
                'coverageTool': templateBuilder.basicHeader('coverageTool', 'Forecast publicly visible in coverage tool'),
	            'borderName' : templateBuilder.basicHeader('borderName', 'Borders')
	        }, // end headers

	        /**
	         * DATA TEMPLATES -------------------------------------------------------
	         */
	        'templates' : {
	            'name' : templateBuilder.linkNode('${url}', '${name}'),
	            'coverageConfName' : templateBuilder.linkNode('${coverageConfUrl}', '${coverageConfName}'),
	            'forecast' : templateBuilder.booleanNode('${forecast}'),
	            'coverageCloned' : templateBuilder.booleanNode('${coverageCloned}'),
	            'lastCoverageRunningDate' : templateBuilder.basicNode('${lastCoverageRunningDate}'),
	            'authorName' : templateBuilder.linkNode('${authorUrl}', '${authorName}'),
	            'readOnlyMode' : templateBuilder.booleanNode('${readOnlyMode}'),
	            'coverageTool' : templateBuilder.booleanNode('${coverageTool}'),
	            'borderName' : templateBuilder.linkNode('${borderUrl}', '${borderName}')
	        } // end templates data
    	};
    }; // end function
});

